export default __webpack_public_path__ + "img/pin_icons/surgical_boom_b.png";